import { React, useState, useEffect } from "react";

import FileCard from "../FIleCard/FileCard";

import styles from "./Starred.module.scss";

import Loader from "../Loader/Loader";

import { useSelector, useDispatch } from "react-redux";

import { fetchStarredFiles } from "../service/apiService";
import { fetchFilesRequest } from "../../Redux/Files/FileActions";

function Starred() {
  const dispatch = useDispatch();
  const starredFileData = useSelector((state) => state.allFiles);
  const userData = useSelector(state => state.user)
  let userId = userData && userData.userId && userData.userId;

  useEffect(() => {
    dispatch(fetchFilesRequest());
    dispatch(fetchStarredFiles(userId));
  }, []);

  return starredFileData && starredFileData.loading ? (
    <div>
      <Loader />
    </div>
  ) : (
    <>
      {starredFileData &&
      starredFileData.starredFiles &&
      starredFileData.starredFiles.length !== 0 ? (
        <div className={`container ${styles.starredFileList}`}>
          {starredFileData &&
            starredFileData.starredFiles &&
            starredFileData.starredFiles.map((file) => {
              return (
                <FileCard
                  key={file.fileId}
                  file={file}
                  page={"starred"}
                  filesList={
                    starredFileData &&
                    starredFileData.starredFiles &&
                    starredFileData.starredFiles
                  }
                />
              );
            })}
        </div>
      ) : (
        <h1 className={styles.noFileMessage}>
          {" "}
          You dont have any Important files.{" "}
        </h1>
      )}
    </>
  );
}

export default Starred;
